"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GitLabProject = /** @class */ (function () {
    function GitLabProject(name, path_with_namespace, web_url, description, avatar_url) {
        this.name = name;
        this.path_with_namespace = path_with_namespace;
        this.web_url = web_url;
        this.description = description;
        this.avatar_url = avatar_url;
    }
    return GitLabProject;
}());
exports.GitLabProject = GitLabProject;
//# sourceMappingURL=GitLabProject.js.map